import { render, staticRenderFns } from "./OrderMailLogs.vue?vue&type=template&id=88db6254&scoped=true&"
import script from "./OrderMailLogs.vue?vue&type=script&lang=ts&"
export * from "./OrderMailLogs.vue?vue&type=script&lang=ts&"
import style0 from "./OrderMailLogs.vue?vue&type=style&index=0&id=88db6254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88db6254",
  null
  
)

export default component.exports